/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecipientCommentsAwaitingAnswerCountQueryVariables = Types.Exact<{
  surveyContentType: Types.SurveyContentType;
}>;


export type RecipientCommentsAwaitingAnswerCountQuery = { global: { id: string, recipientCommentsAwaitingAnswerCount: number } };


export const RecipientCommentsAwaitingAnswerCountDocument = gql`
    query RecipientCommentsAwaitingAnswerCount($surveyContentType: SurveyContentType!) {
  global: getStatisticsGlobal(surveyContentType: $surveyContentType) {
    id
    recipientCommentsAwaitingAnswerCount: number_of_recipient_comments(processing_status: awaiting)
  }
}
    `;

/**
 * __useRecipientCommentsAwaitingAnswerCountQuery__
 *
 * To run a query within a React component, call `useRecipientCommentsAwaitingAnswerCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientCommentsAwaitingAnswerCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientCommentsAwaitingAnswerCountQuery({
 *   variables: {
 *      surveyContentType: // value for 'surveyContentType'
 *   },
 * });
 */
export function useRecipientCommentsAwaitingAnswerCountQuery(baseOptions: Apollo.QueryHookOptions<RecipientCommentsAwaitingAnswerCountQuery, RecipientCommentsAwaitingAnswerCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipientCommentsAwaitingAnswerCountQuery, RecipientCommentsAwaitingAnswerCountQueryVariables>(RecipientCommentsAwaitingAnswerCountDocument, options);
      }
export function useRecipientCommentsAwaitingAnswerCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipientCommentsAwaitingAnswerCountQuery, RecipientCommentsAwaitingAnswerCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipientCommentsAwaitingAnswerCountQuery, RecipientCommentsAwaitingAnswerCountQueryVariables>(RecipientCommentsAwaitingAnswerCountDocument, options);
        }
export type RecipientCommentsAwaitingAnswerCountQueryHookResult = ReturnType<typeof useRecipientCommentsAwaitingAnswerCountQuery>;
export type RecipientCommentsAwaitingAnswerCountLazyQueryHookResult = ReturnType<typeof useRecipientCommentsAwaitingAnswerCountLazyQuery>;
export type RecipientCommentsAwaitingAnswerCountQueryResult = Apollo.QueryResult<RecipientCommentsAwaitingAnswerCountQuery, RecipientCommentsAwaitingAnswerCountQueryVariables>;